// extracted by mini-css-extract-plugin
export default {"select-catalog-size-step-options":"a5QQEn","selectCatalogSizeStepOptions":"a5QQEn"};